import React, { useState } from 'react';
import PropTypes from 'prop-types';

import styled, { withTheme } from 'styled-components';

import Box from '@g4/boneyard/lib/Box';

import Menu, { MenuLinkImage } from '../TopMenu/Menu';
import { FlyoutToggle } from '../TopMenu/FlyoutMenu';
import useBodyScrollLock from '../useBodyScrollLock';

import menuIcon from '../../images/ic-menu-blue.svg';

const Container = styled.div`
  z-index: 8;
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
`;

const Drawer = styled(Box)`
  color: ${props => props.theme.colors.hob.topMenu.drawer.link};
  width: 85vw;
  height: calc(100vh - 50px);

  z-index: 10;

  display: flex;
  flex-direction: column;

  box-shadow: -2px 2px 6px rgba(51, 51, 51, 0.4);

  transition: all 0.3s ease-out;
  padding: 35px 10px 35px 30px;
`;

const ItemList = styled.ul`
  color: ${props => props.theme.colors.hob.topMenu.drawer.link};
  height: 100%;
`;

const Backdrop = styled.div`
  width: 100%;
  height: 100%;

  background-color: rgba(51, 51, 51, 0.8);
  z-index: 9;
`;

const StyledFlyoutToggle = styled(FlyoutToggle)`
  background-color: ${props => props.theme.colors.hob.topMenu.linkBg};
`;

const targetElementStyles = {
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
};

const OffCanvasDrawer = props => {
  const [showDrawer, setShowDrawer] = useState(false);
  const toggleDrawer = e => {
    e.stopPropagation();
    setShowDrawer(!showDrawer);
  };

  const targetElement = useBodyScrollLock(showDrawer);

  return (
    <Menu>
      <StyledFlyoutToggle center alignIcon="center" withArrow={false}>
        <MenuLinkImage src={menuIcon} alt="" onClick={toggleDrawer} />
      </StyledFlyoutToggle>

      {showDrawer && (
        <Container>
          <Backdrop onClick={toggleDrawer} />

          <Drawer
            position="fixed"
            top={50}
            right={0}
            backgroundColor={props.theme.colors.hob.topMenu.link}
          >
            {/** please leave this as it is; otherwise ref wouldn't be passed down to a 
              styled-component; scroll lock would work, but scrolling on the target 
              would not be possible 
              TODO: React.forwardRef()?
              */}
            <div ref={targetElement} style={targetElementStyles}>
              <ItemList>{props.children}</ItemList>
            </div>
          </Drawer>
        </Container>
      )}
    </Menu>
  );
};

OffCanvasDrawer.propTypes = {
  theme: PropTypes.object,
  children: PropTypes.node,
};

export default withTheme(OffCanvasDrawer);
